module.exports = __webpack_public_path__ + "img/inspect_3 - 副本.b9ebb4dd.png";